/**
 * Superadmin Sidebar
 */

import { Link, useLocation } from 'react-router-dom';
import {
  UsersIcon,
  CreditCardIcon,
  RectangleStackIcon,
  ChartBarIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const navigation = [
  { name: 'Tenants', href: '/superadmin/tenants', icon: UsersIcon },
  { name: 'Plans', href: '/superadmin/plans', icon: RectangleStackIcon },
  { name: 'Billing', href: '/superadmin/billing', icon: CreditCardIcon },
];

export default function SuperadminSidebar({ open, onClose }) {
  const location = useLocation();

  return (
    <div
      className={`
        fixed lg:static inset-y-0 left-0 z-30
        w-64 bg-purple-950 text-white flex flex-col
        transform transition-transform duration-300 ease-in-out
        ${open ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0
      `}
    >
      {/* Header */}
      <div className="p-4 border-b border-purple-800 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-bold text-white">Superadmin</h1>
          <p className="text-xs text-purple-400 mt-0.5">Platform control</p>
        </div>
        <button
          onClick={onClose}
          className="lg:hidden text-purple-400 hover:text-white p-1 rounded"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>

      {/* Nav */}
      <nav className="flex-1 p-4 space-y-1">
        {navigation.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname.startsWith(item.href);
          return (
            <Link
              key={item.name}
              to={item.href}
              onClick={onClose}
              className={`flex items-center px-3 py-2.5 rounded-lg transition-colors ${
                isActive
                  ? 'bg-purple-700 text-white'
                  : 'text-purple-300 hover:bg-purple-800 hover:text-white'
              }`}
            >
              <Icon className="w-5 h-5 mr-3 flex-shrink-0" />
              <span className="font-medium">{item.name}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-purple-800">
        <div className="text-xs text-purple-500">Massage Studio Suite</div>
      </div>
    </div>
  );
}
